import { render, staticRenderFns } from "./SchemaPage.vue?vue&type=template&id=538f63b6&scoped=true"
import script from "./SchemaPage.vue?vue&type=script&lang=js"
export * from "./SchemaPage.vue?vue&type=script&lang=js"
import style0 from "./SchemaPage.vue?vue&type=style&index=0&id=538f63b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "538f63b6",
  null
  
)

export default component.exports